import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom"
import { EventNotificationService, useEventNotification } from "../../framework/services/event-notification";
import { getAppRouteByPathname, getNextShoppingUrl } from "../app-routes";
import { AppRoutes } from "../../app-shop/app-routes";
import { CustomerAccountService } from "../../services/customer-account";
import { ShopAppEvents } from "../events";
import * as H from 'history';

const subscriberId = 'ShopApp.Service.PageManager';

// You can't change the route in the middle of a useEffect.
// When we decide to redirect, first we wait until it has run its course
const navigateTo = (url: string, history: H.History<unknown>) => {
    window.setTimeout(() => history.push(url), 100);
}

export const usePageManager = () => {
    const location = useLocation();
    const history = useHistory();

    useEventNotification(() => history.push(AppRoutes.start.url()), [history], ShopAppEvents.ForceSignIn, subscriberId);

    useEffect(() => {
        const currentRoute = getAppRouteByPathname(location.pathname);
        // send unknown+unauthenticated routes to sign in, but send unknown+authenticated routes home.
        // Home will, in turn, send the user to the most appropriate place based on context
        if(!currentRoute) {
            if (CustomerAccountService.isAuthenticated()) {
                navigateTo(AppRoutes.home.url(), history);
            } else {
                navigateTo(AppRoutes.start.url(), history);
            }
        }
        // if the current route is known and requires sign in,
        // and the user is not signed in, send the to the sign in page
        else if (!!currentRoute && currentRoute.allowAnonymous === false 
                && CustomerAccountService.isAuthenticated() === false) {
            navigateTo(AppRoutes.start.url(), history);
        }
        // if the current route is known, requires sign in, and the user is signed in,
        // we still need to verify that contextually, it makes for the user to be on this page.
        // If their presence here doesn't make sense, we send them the next logical place that does
        else if(!!currentRoute && currentRoute.allowAnonymous === false && CustomerAccountService.isAuthenticated()) {
            CustomerAccountService.getProjectConfiguration()
            .then(config => {
                if(!!config && currentRoute.isContextCompatible(config) === false) {
                    navigateTo(getNextShoppingUrl(config), history);
                }
            });
        }

        !!currentRoute && EventNotificationService.dispatch(ShopAppEvents.UpdateHeaderConfiguration, currentRoute.headerConfig);
    }, [location, history]);
}